import styled from "styled-components";

import { Container } from "@olist/templates";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
`;

export const PageWrapper = styled(Container)`
  flex: 1;
  height: 100%;
  padding-bottom: 64px;
  position: relative;
`;
